import React, { useState } from 'react';

const CollapsibleSection = ({ title, children, defaultOpen = false, icon = '📋' }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-emerald-200 rounded-lg overflow-hidden mb-4 bg-white shadow-sm">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 bg-emerald-50 hover:bg-emerald-100 transition-colors"
      >
        <div className="flex items-center space-x-3">
          <span className="text-2xl">{icon}</span>
          <h3 className="text-lg font-semibold text-emerald-800">{title}</h3>
        </div>
        <svg
          className={`w-6 h-6 text-emerald-600 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="p-6 bg-white">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
